import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PayAccountForm from '../forms/PayAccountForm'
import globals from '../globals'
import DataSource from '../DataSource'
import Button from '../elements/Button'

class InterimPayment extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: true,
            hasError: false,
            failedAmount: 0,
            failedReason: '',
            failedDate: ''
        }
    }

    componentDidMount () {
        // Backend doesnt support paying failed payment with interim yet
        // this.getData();
    }

    handleFailure (response, state) {
        const stateClone = Object.assign({}, state)
        stateClone.credit_card_number = new Array(stateClone.credit_card_number.length + 1).join('*')
        stateClone.credit_card_cvc = new Array(stateClone.credit_card_cvc.length + 1).join('*')
    }

    getData () {
        DataSource.getData('/api/getFailedAmountOwing', response => {
            this.setState({
                failedAmount: response.amount,
                failedReason: response.reason,
                failedDate: response.date,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        const Balance = () => {
            if (this.state.failedAmount > 0) {
                return (
                    <div className='row-error'>
                        <p className='bold m-0 mb-1'>Failed payment notice</p>
                        <p className='m-0 mb-2'>On <span className='bold'>{this.state.failedDate}</span> your financial institution declined your Exetel payment of <span className='bold'>${this.state.failedAmount}</span> for the following reason:<br /><span className='bold'>{this.state.failedReason}</span>.</p>
                        <p className='m-0'>This amount will be added to your interim payment amount below. If you are making a payment to re-activate your service, please allow 30 minutes for your service to switch on.</p>
                    </div>
                )
            }

            return <p>Your current spend limit and the payment amount required is <span className='bold'>${(this.props.serviceDetails.interimAmount + this.state.failedAmount)}</span>.</p>
        }

        const setSuccessMsg = (response, values) => {
            return <div className='text-center'>Interim amount successfully paid. Your service will be back online within the next 10 minutes.<br /><br /><Button title='Back to my service' href={`/my-services/mobile/${this.props.serviceId}`} /></div>
        }

        return (
            <div className='pay-account module' style={{ overflow: 'visible' }}>
                <Heading title='Interim payment' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                    {this.props.serviceDetails.interimAmount <= 0
                        ? <div className='p-4'>
                            <p className='text-center'>You have not reached your spending maximum for this service so you are unable to make an interim payment right now.<br /><br />If you have been directed here by us, please give us a call on 13 39 38.</p>
                          </div>
                        : <div className='row p-4'>
                            <div className='col-12 col-md-8 offset-md-2 text-center'>
                                <p>
                                    The spend limit on your mobile service has reached it's maximum of ${this.props.serviceDetails.cappedSpend}. In order for you to continue using your service
                                    (within this billing period) you will need to make an interim payment of ${this.props.serviceDetails.interimAmount} to reset your spend limit back to $0.
                                    <br />
                                    Note: Your service will automatically reset on {this.props.serviceDetails.nextBillingCycleStart}
                                </p>
                                {Balance()}
                            </div>
                            <div className='col-12 col-md-6 offset-md-3'>
                                <PayAccountForm
                                    failedAmount={(this.props.serviceDetails.interimAmount + this.state.failedAmount)}
                                    handleSuccess={() => globals.pushEvent('PayAccountInterimSubmit')}
                                    handleFailure={this.handleFailure.bind(this)}
                                    setSuccessMsg={setSuccessMsg}
                                    additionalFields={{
                                        charge_type: 'interim',
                                        service_id: this.props.serviceId,
                                        service_type: 'MOBILE'
                                    }}
                                />
                            </div>
                          </div>}
                </ModuleWithLoader>
            </div>
        )
    }
}

InterimPayment.propTypes = {
    serviceDetails: PropTypes.shape({
        nextBillingCycleStart: PropTypes.string.isRequired,
        cappedSpend: PropTypes.number.isRequired,
        interimAmount: PropTypes.number.isRequired
    }).isRequired
}

export default InterimPayment



// WEBPACK FOOTER //
// ./resources/js/modules/InterimPayment.js